module.exports = __webpack_public_path__ + "icon_services_status_maintenance.f988b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/icon_services_status_maintenance.svg
// module id = ./src/_asset/sources/assets/images/icon_services_status_maintenance.svg
// module chunks = main